let disallowedDomains = process.env.REACT_APP_DISALLOWED_DOMAINS.split(", ");

export const isDisallowedEmail = (email) => {
  const domain = email.split("@")[1];
  return disallowedDomains.includes(domain);
};

export const randColorClass = () => {
  const colors = [
    "bg-red-300",
    "bg-yellow-300",
    "bg-green-300",
    "bg-blue-300",
    "bg-indigo-300",
    "bg-purple-300",
    "bg-pink-300",
  ];
  return colors[Math.floor(Math.random() * colors.length)];
};
